import { Vue, Component, Watch, Prop } from "vue-property-decorator";

@Component({
	components: {},
})
export default class ProductInfo extends Vue {
	@Prop({ default: () => {} })
	value: ItemObject;

	// 0 主图  其他  商详图片
	@Prop()
	mainImage: number;

	render(h) {
		return (
			<div class="hei-75 center font-size-14 bg-grey-6" style={" line-height: 150px;"}>
				{this.mainImage === 0 ? <el-image src="https://ssl-picture.tenyun.runsasoft.com/shangpingzhutu.jpeg" /> : <el-image src="https://ssl-picture.tenyun.runsasoft.com/shangpingxiangqing.jpeg" />}
			</div>
		);
	}
}
